import { render, staticRenderFns } from "./agilityTable.vue?vue&type=template&id=5f641a68&scoped=true"
import script from "./agilityTable.vue?vue&type=script&lang=js"
export * from "./agilityTable.vue?vue&type=script&lang=js"
import style0 from "./agilityTable.vue?vue&type=style&index=0&id=5f641a68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f641a68",
  null
  
)

export default component.exports